import { render, staticRenderFns } from "./LogDetailsModal.vue?vue&type=template&id=b4ffd112&scoped=true&"
import script from "./LogDetailsModal.vue?vue&type=script&lang=js&"
export * from "./LogDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./LogDetailsModal.vue?vue&type=style&index=0&id=b4ffd112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ffd112",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
